export default __webpack_public_path__ + "static/stk-praha-intro-b68d1cdf64bf1173cb74690f86ec3a46.mp4";